import { ADD_SURVEY_ROUTE, CATALOGUE_ROUTE, HELP_ROUTE } from '@/domains/auth';

/**
 * Where the Advisor Portal's screens live (`docs/superpowers/specs/2026-09-28-two-portals-design.md`,
 * §3 and §6) — spelled in the survey domain for the reason `domains/admin/paths.ts` gives for the
 * Team Portal's: the screens link to one another, and the zone only mounts them.
 *
 * Three of these are the auth domain's constants rather than spellings of their own. Help is the
 * one portal page reachable signed out — registration's refusals lead to it before any account
 * exists — and the anonymous routes are all spelled there. The catalogue and "Add a survey" are
 * where a registration inside an account lands and lives (`RegistrationPage`, in its `account`
 * mode), so the auth domain names them and this table reads them back, one spelling each.
 *
 * `/survey/*` redirects to `surveys` from `src/legacy-routes.tsx`, and nothing else still spells it.
 */

export const PORTAL_ROOT = '/portal';

export const PORTAL_PATHS = {
  home: PORTAL_ROOT,
  surveys: CATALOGUE_ROUTE,
  addSurvey: ADD_SURVEY_ROUTE,
  profile: `${PORTAL_ROOT}/profile`,
  documents: `${PORTAL_ROOT}/documents`,
  account: `${PORTAL_ROOT}/account`,
  help: HELP_ROUTE
} as const;

/** One response, open for filling — or read-only, when it can no longer be written. */
export function responseFormPath(responseId: string): string {
  return `${PORTAL_PATHS.surveys}/${encodeURIComponent(responseId)}`;
}

/** A submitted response's receipt. */
export function receiptPath(responseId: string): string {
  return `${responseFormPath(responseId)}/submitted`;
}

/** Where a team answers its own routing questions (the teams onboarding plan's R9) — under the
 *  catalogue, which is what sends a team there while survey-api has routed it nowhere. */
export function teamRoutingPath(participantId: string): string {
  return `${PORTAL_PATHS.surveys}/teams/${encodeURIComponent(participantId)}/routing`;
}
